import { render, staticRenderFns } from "./attach-file-show.vue?vue&type=template&id=167f26e9&scoped=true&"
import script from "./attach-file-show.vue?vue&type=script&lang=js&"
export * from "./attach-file-show.vue?vue&type=script&lang=js&"
import style0 from "./attach-file-show.vue?vue&type=style&index=0&id=167f26e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f26e9",
  null
  
)

export default component.exports